module.exports = __webpack_public_path__ + "static/assets/d8110803ceae59f36bdeed6af8bf5802.svg";